<template>
  <div class="common_panel">
    <div class="common_panel_header">
      <div class="video" @click="onvideoClick"></div>

      <div class="close" @click="onClose"></div>
    </div>

    <div v-if="title != '监控视频'" class="common_panel_body">
      <div class="body_right">
        <div :title="item" class="rightItem" v-for="(item, index) in rightList" :key="'rightList' + index">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'eventLayerPanel',
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {},
  destroyed() {},
  data() {
    return {
      rightList: ['非 法 传 入', '2023年3月31日 18:00:00', '浙江省温州市平阳县火焜岙村5号'],
      title: '应急事件'
    };
  },
  computed: {
    ...mapState(['highLight', 'prevModelLayer', 'landmarkLayerIdObj'])
  },
  methods: {
    onClose() {
      this.$emit('onClose');
    },
    onvideoClick() {
      
      this.$store.commit('setHighLight', '打开融合通讯');
 
    }
  }
};
</script>

<style lang="less" scoped>
.common_panel {
  transform: scale(1.25);
  transform-origin: center bottom;
  pointer-events: all;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 320px;
  height: 140px;
  min-height: 84px;
  line-height: 70px;
  background: rgba(0, 0, 0, 0.5);
  background-image: url('./Img/eventpanel.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  font-size: 32px;
  color: #fff;
  font-family: '微软雅黑';
  .close {
    transform: scale(0.25);
    pointer-events: all;
    width: 18px;
    height: 18px;
    // background: url('../../assets/img/GisPanel/close.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: -14px;
    right: 10px;
  }

  .titys {
    position: absolute;
    left: 90px;
    top: 5px;
  }
  .common_panel_header {
    display: flex;
    position: relative;
    justify-content: space-between;
    box-sizing: border-box;
    height: 26px;
    padding: 0 13px;
    top: 8px;
    .title {
      font-family: '碳纤维正中黑简体';
      font-size: 48px;
      color: #ffffff;
      position: absolute;
      margin-left: 20px;
      margin-top: 10px;
      text-align: start;
      width: 400px;
    }
    .close {
      transform: scale(0.5);
      width: 48px;
      height: 49px;
      background: url('./Img/close.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: -10px;
      right: 10px;
    }
    .video {
      width: 33px;
      height: 25px;
      background: url('./Img/摄像头.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 2px;
      right: 60px;
    }
  }
  .common_panel_body {
    width: 427px;
    transform: scale(0.4);
    display: flex;
    justify-content: space-between;

    font-size: 16px;
    margin: 0px auto;
    margin-top: -33px;
    .body_left {
      height: 100%;
      width: 314px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #bfebff;
      line-height: 24px;
      .leftItem {
        width: 100%;
        height: 74px;
        background: #00000035;
        display: flex;
        font-family: '碳纤维正中黑简体';
        font-size: 30px;
        box-sizing: border-box;
        padding-left: 15px;
        line-height: 80px;
      }
    }
    .body_right {
      height: 100%;
      width: 382px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #fff;
      .rightItem {
        font-family: '微软雅黑';
        width: 100%;
        height: 64px;
        font-size: 32px;

        line-height: 70px;
        box-sizing: border-box;
        padding: 0 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .rightItemzx {
        color: #4cffd2;
        width: 100%;
        height: 24px;
        background: #00000020;
        line-height: 24px;
        box-sizing: border-box;
        padding: 0 5px;
      }
    }
  }
}
</style>
